import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // ✅ استرجع اللغة من localStorage أو استخدم 'en' كافتراضي
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  // ✅ تحديث اتجاه الصفحة (RTL/LTR) وحفظ اللغة في localStorage
  useEffect(() => {
    document.dir = language === "ar" ? "rtl" : "ltr";
    localStorage.setItem('language', language);
  }, [language]);

  // ✅ دالة تبديل اللغة - تشتغل مع الـ toggle والـ select
  const toggleLanguage = (e) => {
    // لو جاي من select dropdown
    if (e?.target?.value) {
      setLanguage(e.target.value)
    } 
    // لو جاي من toggle button عادي
    else {
      setLanguage((prev) => (prev === "en" ? "ar" : "en"));
    }
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};